import bankLogo from '../../../assets/payment-methods/bank.svg';
import callpayLogo from '../../../assets/payment-methods/callpay.png';
import cardLogo from '../../../assets/payment-methods/card.svg';
import cryptoLogo from '../../../assets/payment-methods/crypto.png';
import stripeIdealLogo from '../../../assets/payment-methods/ideal.png';
import paypalLogo from '../../../assets/payment-methods/paypal.svg';
import stripeLogo from '../../../assets/payment-methods/stripe.png';
import xmoneyLogo from '../../../assets/payment-methods/xmoney.png';
import phonepeLogo from '../../../assets/payment-methods/phonepe.svg';

const TYPE_PAYPAL = 'paypal';
export const TYPE_STRIPE = 'stripe';
const TYPE_STRIPE_IDEAL = 'stripe_ideal';
const TYPE_STRIPE_BITCOIN = 'stripe_bitcoin';
const TYPE_CALLPAY = 'callpay';
const TYPE_CRYPTO = 'crypto';
const TYPE_UTRUST = 'utrust';
export const TYPE_TWISPAY = 'twispay';
export const TYPE_MOBILPAY = 'mobilpay';
export const TYPE_AMAZON_PAYMENT_SERVICES = 'amazon_payment_services';
export const TYPE_PHONEPE = 'phonepe';
export const TYPE_SHIFT4 = 'shift4';
const TYPE_BANK = 'bank';

export const getPaymentMethodLogo = type => {
  switch (type) {
    case TYPE_PAYPAL:
      return paypalLogo;
    case TYPE_STRIPE:
      return cardLogo;
    case TYPE_STRIPE_IDEAL:
      return stripeIdealLogo;
    case TYPE_STRIPE_BITCOIN:
      return stripeLogo;
    case TYPE_CALLPAY:
      return callpayLogo;
    case TYPE_CRYPTO:
      return cryptoLogo;
    case TYPE_UTRUST:
      return xmoneyLogo;
    case TYPE_TWISPAY:
      return cardLogo;
    case TYPE_MOBILPAY:
      return cardLogo;
    case TYPE_BANK:
      return bankLogo;
    case TYPE_AMAZON_PAYMENT_SERVICES:
      return cardLogo;
    case TYPE_PHONEPE:
      return phonepeLogo;
    case TYPE_SHIFT4:
      return cardLogo;
  }
};
